import axios from 'axios'
import Qs from 'qs'
import config from "../../WebConfig";
import { Dialog } from 'vant';

var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
let IsWX = false
if (ua.match(/MicroMessenger/i) == "micromessenger") {
    IsWX = true
}

export function post(url,data,success,fail,complete){
	data.token = getCookie('token');
	if(localStorage.getItem("ActData")){
		data.actid = JSON.parse(localStorage.getItem("ActData")).id;
	}
	console.log(config.ROOT+url);
	var req = axios.post(config.ROOT+url,Qs.stringify(data),{
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
			'token':data.token
		}
	})
	.then(function(res){
		console.log(res);
		if(res.data.code==0){
			Dialog.alert({
			  title: '温馨提示',
			  message: res.data.msg
			}).then(() => {
			});
		}else{
			success && success(res.data);
		}
		complete && complete();
	})
	.catch(function(err){
		console.log(err)
		if(err.response) {
			if(err.response.data.code==401){
				//未登录
				if(IsWX){
					var url = window.location.href.replace('#',"/octothorpe");
					window.location.href=config.PROXYROOT+'/addons/qrcodeshop/api.uservue/connect?platform=wechat&url='+url;
				}
				else
				    window.location.href=config.ROOT+'/index/user/login';
			}
			console.log(err.response)
		}
		fail && fail(err);
		complete && complete();
	})
}


export function get(url,data,success,fail,complete){
	data.token = getCookie('token');
	if(localStorage.getItem("ActData")){
		data.actid = JSON.parse(localStorage.getItem("ActData")).id;
	}
	console.log(config.ROOT+url);
	var req = axios.get(config.ROOT+url,{params:data})
	.then(function(res){
		console.log(res);
		if(res.data.code==0){
			Dialog.alert({
			  title: '温馨提示',
			  message: res.data.msg
			}).then(() => {
			});
		}else{
			success && success(res.data);
		}
		complete && complete();
	})
	.catch(function(err){
		console.log(err)
		if(err.response) {
			if(err.response.data.code==401){
				//未登录
				if(IsWX){
					var url = window.location.href.replace('#',"/octothorpe");
					window.location.href=config.PROXYROOT+'/addons/qrcodeshop/api.uservue/connect?platform=wechat&url='+url;
				}
				else
				    window.location.href=config.ROOT+'/index/user/login';
			}
			console.log(err.response)
		}
		fail && fail(err);
		complete && complete();
	})
}

function getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	let _token = getUrlParam("token")
	if (_token){
		setCookie(c_name,_token)
		localStorage.setItem("token", _token)
		return _token;
	}


	if (document.cookie.length>0){
		var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
		if (c_start!=-1){ 
			c_start=c_start + c_name.length+1 
			var c_end=document.cookie.indexOf(";",c_start)
			if (c_end==-1) c_end=document.cookie.length
			_token =  unescape(document.cookie.substring(c_start,c_end))
			} 
		}

	if (_token){
		setCookie(c_name,_token)
		localStorage.setItem("token", _token)
		return  _token;
	}
	return ""
}


function setCookie(name,value)
{
	var Days = 30;
	var exp = new Date();
	exp.setTime(exp.getTime() + Days*24*60*60*1000);
	document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+";path=/";
}


function getToken() {

	let _token = localStorage.getItem('token');
	if (_token != null && _token.length > 10) {
		return _token;
	}
	_token = getUrlParam("token");
	console.log("getToken",_token);
	localStorage.setItem("token", _token)
	return  _token;
}

function getUrlParam(name) {  // 获取url参数值
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	//构造一个含有目标参数的正则表达式对象
	var str = window.location.href.split("?")[1];
	if (str) {
		var r = str.substr(0).match(reg);
		//匹配目标参数
		if (r != null)
			return decodeURI(r[2]);
		return '';
	} else {
		return ''
	}
}